export const readFileAsText = (file: File) => {
    return new Promise((resolve) => {
        const reader = new FileReader();

        reader.addEventListener('load', () => {
            resolve(reader.result as string);
        });

        reader.readAsText(file);
    }) satisfies Promise<string>;
};
